import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=664e80c5&"
import script from "./TaskForm.vue?vue&type=script&lang=ts&"
export * from "./TaskForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports